import React from "react"
import { Link, Stack, Typography } from "@mui/material"
import { dsColorNew } from '@palette'
import { DS_REPRICING_ROUTES } from "@constants/routes"
import { dsRepricingDrawerData } from "Pages/DsRepricing/Page/@signals"
import DsRepricingFilterTariffType from "Pages/DsRepricing/Page/@components/FilterTariffType"
import DsRepricingFilterInsurances from "Pages/DsRepricing/Page/@components/FilterInsurances"
import { faceScopeSummary } from "Pages/DsRepricing/Page/@services/faceScope"
import { useAxisCatalog } from "Pages/DsRepricing/Setup/@services/axes"

// Which of our own rows the rule prices (CU-869fe6mf4): the two axes a
// strategy can be scoped by, like it is scoped by office. They decide
// *whether the rule acts on a row of ours* — judged on the row's own
// tariff type and insurance, not on the rate card's axes, so a rate
// card that leaves an axis blank is covered on every kind of it
// (CU-869fh646w, Curro 2026-10-14). They never touch who the rule is
// compared against: that is card 7, "Which kinds of offer".
//
// The caption at the foot is the one place the operator is told, at
// the moment of choosing, where the rows this rule leaves out will
// show — and that a rate card none of whose rows any strategy covers
// is a No strategy in the Activity. It cannot be a validation: whether
// that happens depends on a pass that has not run yet. So it is a
// caption, not an Alert, and it opens the Activity in a new tab so the
// form is not lost.
const noStrategyHref = `${DS_REPRICING_ROUTES.ACTIVITY_PATH}?event_type=no_strategy`

export default function DsRepricingFaceScope() {
	const axes = useAxisCatalog()
	const data = dsRepricingDrawerData.value || {}
	const scoped = faceScopeSummary({
		tariffTypes: data.filterTariffTypes,
		insurances: data.filterInsurances,
		insurancesExclusion: data.filterInsurancesExclusion,
	}, axes)

	return (
		<Stack gap={2.5}>
			<DsRepricingFilterTariffType/>
			<DsRepricingFilterInsurances/>
			{scoped && (
				<Typography component="span" sx={{ fontSize: 12, color: dsColorNew.textMuted, display: 'block' }}>
					Scoped to <strong>{scoped}</strong>. Our rows of another tariff type or insurance
					are not priced by this rule; the Activity detail lists them as left out. A rate
					card whose rows no strategy covers at all appears as{' '}
					<Link href={noStrategyHref} target="_blank" rel="noopener noreferrer">
						No strategy in the Activity log
					</Link>.
				</Typography>
			)}
		</Stack>
	)
}
